import React, { FC } from "react";
import { ConnectedProps, connect } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { IUhfViewState } from "../../../../pages/Contracts";
import { IRapComponentProperties } from "../../../../platform/Layout";
import { FlexContainer } from "../../../../common/components/FlexContainer/FlexContainer";
import { PartnerSelector } from "../PartnerSelector/PartnerSelector";
import { HeaderSelector } from "../HeaderSelector/HeaderSelector";
import { FooterSelector } from "../FooterSelector/FooterSelector";
import { LocaleSelector } from "../LocaleSelector/LocaleSelector";
import { OptionsSelector } from "../OptionsSelector/OptionsSelector";
import { EnvironmentSelector } from "../EnvironmentSelector/EnvironmentSelector";

import "./TestConfigurator.scss";

interface ITestConfiguratorProvidedProps extends IRapComponentProperties {

}

interface ITestConfiguratorOwnProps {

}

export type ITestConfiguratorProps = ConnectedProps<typeof connector> & ITestConfiguratorProvidedProps;

const TestConfiguratorInitializer: FC<ITestConfiguratorProps> = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    
    let alpineTest = searchParams.get("alpine") == "true" || searchParams.get("alpine") == "1";
    return (
        <FlexContainer direction={"row"} wrap="wrap" gap={20} className="c-configContainer">
            <FlexContainer direction={"column"} gap={20} flex>
                <PartnerSelector className="c-fieldContainer"/>
                <HeaderSelector className="c-fieldContainer"/>
                <FooterSelector className="c-fieldContainer"/>
            </FlexContainer>
            <FlexContainer direction={"column"} gap={10} flex>
                <LocaleSelector className="c-fieldContainer"/>
                <OptionsSelector/>
                {!alpineTest && (
                    <EnvironmentSelector/>
                )}
            </FlexContainer>
        </FlexContainer>
    );
}

function mapStateToProps(state: IUhfViewState, providedProps: ITestConfiguratorProvidedProps): Partial<ITestConfiguratorOwnProps> {
    return {
        ...providedProps,
    };
}

const ActionsToDispatch = {

};

const connector = connect(
    mapStateToProps,
    ActionsToDispatch,
    null,
    { forwardRef: true }
);

export const TestConfigurator = connector(TestConfiguratorInitializer);